// please avoid using jquery
// do clean code with proper comments

$(document).ready(function(){

  $("ul.clickyboxes li a").removeClass("active");	
  
  theme.calc100vh = function() {
    var nav = document.getElementById('site-control');
    document.documentElement.style.setProperty('--viewport-height-first-section',
      `${(nav.dataset.opacity === 'opaque') ? window.innerHeight - nav.clientHeight : window.innerHeight}px`);
    document.documentElement.style.setProperty('--viewport-height',
      (nav.dataset.opacity.indexOf('opaque') > -1 && nav.dataset.positioning === "sticky") ? `calc(100vh - ${nav.clientHeight}px)` : "100vh");
  }
  theme.calc100vh();
  
  const annoucebarMobileSlider = new Swiper(".annouce-bar-slide", {
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
  });                        
  
  $(window).scroll(function(){
    var sticky = $('#backToTop'),
        scroll = $(window).scrollTop(),
        inhherHeight = $(window).height() * 1.2;
    if (scroll >= inhherHeight) sticky.fadeIn();
    else sticky.fadeOut();
  });
  $('#backToTop').click(function(){
    $('html, body').animate({
      scrollTop: 0
    }, 800); 
  })
  if (window.innerWidth <= 767) {
    // mobile footer layout changes
    const footerSocial = document.querySelector('.section-footer .section-footer__text-block__social');
    const footerPaymentNode = document.querySelector('.section-footer__row-lower .section-footer__row__col');
    footerPaymentNode.appendChild(footerSocial);

    const menuTrigger = document.querySelectorAll('.section-footer__menu-block .section-footer__title');
    menuTrigger.forEach(ele => {
      ele.addEventListener('click', (e) => {
        if (ele.classList.contains('active')) {
          ele.classList.remove('active');
          ele.nextElementSibling.classList.remove('active');
        }else{
          ele.classList.add('active');
          ele.nextElementSibling.classList.add('active');
        }
      })
    });
  }else{
    // pdp gallery
    const ppdSLider = new Swiper(".theme-viewport.swiper-container", {
      autoHeight: true
    });
    let currPdpSlide = document.querySelectorAll('.product-area__details__thumbs .product-area__details__thumbs__thumb');
    currPdpSlide.forEach(ele => {
      ele.addEventListener('click', () => {
        let index = ele.getAttribute('data-slick-index');
        ppdSLider.slideTo( index ,1000,false);
      })
    });
  }

  // pdp lightbox
  new FsLightbox();

  // pdp description read more 
  const PdpReadBtnTrigger = document.querySelector('#readMore');
  if (PdpReadBtnTrigger) {
    PdpReadBtnTrigger.addEventListener('click', () => {
      let targetBtn = document.querySelector('.product-detail-accordion .prost-descriotion');
      PdpReadBtnTrigger.parentNode.style.display = 'none';
      targetBtn.classList.add('active');
    })
  }

  $('#page-menu.nav-uses-modal .has-children > a').click(function(e){
    e.preventDefault();
    $(this).toggleClass('active').siblings('ul').slideToggle();
  });

  $(document).on('click','#filterTrigger',function(e){
    $(this).toggleClass('active');
    if (window.innerWidth <= 767 ) {
      e.stopPropagation();
      $('.theme-filter-container .cc-product-filter').addClass('-in');
      $('#shopify-section-header').hide();
      $('#gorgias-chat-container').hide();
      $('body').css('overflow','hidden');
    }else{
      $('.theme-filter-container .cc-product-filter').animate({width: 'toggle'});
      $('#shopify-section-header').show();
    }
  });

  $(document).on('click','#FacetsForm .closePopup',function(){
    $('#filterTrigger').removeClass('active');
    $('.theme-filter-container .cc-product-filter').removeClass('-in');
    $('#shopify-section-header').show();
    $('body').removeAttr('style');
    $('#filterTrigger').text('Filters');
    $('#gorgias-chat-container').show();
  });
  if (window.innerWidth <= 767) {
    $(document).on('click', function(e) {
      let pFilter = $('.cc-product-filter');
      if (e.target != pFilter && pFilter.has(e.target).length === 0) {
        $('#FacetsForm .closePopup').trigger('click');
      }
    })
  }
if(window.innerWidth < 767){
// filter arrow
//   filterTrigger
//     $(document).on('click','.active-filter-controls__clear-left a', function(){
//     $('#filterTrigger').trigger('click');
//   });
  setTimeout(function(){
      $(document).on('click','.active-filter-controls__clear-left a', function(){
          $('#filterTrigger').removeClass('active');
      });
  },10);
}

  $(document).on('change', '.cust-filter-header .plp-accordion-item__panel-grid-Sortby input',function(){
    var currVal = $(this).val();
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("sort_by",currVal);
    window.location.search =  searchParams.toString();
  })

  if(window.innerWidth > 767){
    $('.theme-filter-container .cc-product-filter').css('display','block');
  }else{
    $('#filterTrigger').removeClass('active');
    $('#filterTrigger').removeClass('active').text('Filters');
  }

  // homepage img text slider
  $('.media_with_text_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000, 
    arrow: true,
    infinite: true,
    responsive: [ 
      {
        breakpoint: 768,
        settings: { 
          slidesToShow: 1,
          arrow: true,
        }
      } 
    ]
  });

  // homepage testimonial slider
 $('.testimonial').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, 
    arrow: false,
   	dots:true,
    infinite: true,
    responsive: [ 
      {
        breakpoint: 1024,
        settings: { 
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: { 
          slidesToShow: 1
        }
      }
    ]
  });

   // on keypress submit form
  window.cacheTimeout = null;
  $(document).on('keyup','#FacetsForm .cc-price-range__input-row input', function(event){
    clearTimeout(window.timeout);
    window.timeout = setTimeout(function(){
     $('#FacetsForm:not(.submit-btn)').submit(); 
    }, 1000); 
  });


  $(document).on("click",".section-image-with-text-slider #custom-slick-prev",function() {
    $(".section-image-with-text-slider .slick-prev").click();
    $("#custom-slick-next").removeClass("custom-slick-disabled");
    var slickdisableprev = $(".section-image-with-text-slider .slick-prev").attr("aria-disabled");
    if(slickdisableprev == "true"){
      $("#custom-slick-prev").addClass("custom-slick-disabled");
    }else{
      $("#custom-slick-prev").removeClass("custom-slick-disabled");
    }
  });

  $(document).on("click",".section-image-with-text-slider #custom-slick-next",function() {
    $(".section-image-with-text-slider .slick-next").click();
    $("#custom-slick-prev").removeClass("custom-slick-disabled");
    var slickdisablenext = $(".section-image-with-text-slider .slick-next").attr("aria-disabled");

    if(slickdisablenext == "true"){
      $("#custom-slick-next").addClass("custom-slick-disabled");
    }else{
      $("#custom-slick-next").removeClass("custom-slick-disabled");
    }
  });

  $('.plp-accordion-item__panel-grid-Availability,.plp-accordion-item__panel-grid-Price').parent('details').removeAttr('open');
  if (window.innerWidth < 767) {
    $('#FacetsForm.submit-btn .cc-checkbox__input').on('change', function(e){
      e.stopPropagation();
      e.stopImmediatePropagation();
    });
    $(document).on('submit','#FacetsForm.submit-btn',function(e){
      e.preventDefault();
      theme.FilterManager.functions.submitForm('#FacetsForm');  
      $('#FacetsForm .closePopup').trigger('click');
    });
  } 

  // on load show page
  setTimeout(function (){
    $('body').addClass('loaded');
    $('body').css('opacity','1');  
  },80); 
  
});


